const {
  GET_EVIDENCE_LIST,
  GET_EVIDENCE_LIST_SUCCESS,
  GET_EVIDENCE_LIST_FAILURE,
} = require('../../modules/constants');

const getEvidenceListRequest = (state, action) => {
  return {
    ...state,
    isEvidenceLoading: true,
  };
};

const getEvidenceListRequestSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;

  if (data.status === 200) {
    return {
      ...state,
      isEvidenceLoading: false,
      evidenceList: data.data.results,
      evidenceCount: data.data.count,
      evidenceListPageSize: data.data.page_size,
    };
  }
  return {
    ...state,
    isEvidenceLoading: false,
    evidenceList: [],
    evidenceCount: 0,
    evidenceListPageSize: null,
  };
};

const getEvidenceListRequestFailure = (state, action) => {
  return {
    ...state,
    isEvidenceLoading: false,
    evidenceList: [],
    evidenceListPageSize: null,
  };
};

// Action Handlers
const ACTION_HANDLERS = {
  [GET_EVIDENCE_LIST]: getEvidenceListRequest,
  [GET_EVIDENCE_LIST_SUCCESS]: getEvidenceListRequestSuccess,
  [GET_EVIDENCE_LIST_FAILURE]: getEvidenceListRequestFailure,
};

// default initial state
const initialState = {
  isEvidenceLoading: false,
  evidenceList: [],
  evidenceCount: 0,
  evidenceListPageSize: null,
};

export default function evidenceReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}
